import React from 'react';
import {Context} from '../context';

export default function NoOrderHistory(props) {
  const {localeText} = React.useContext(Context);
  return (
    <div>
      {localeText(
        'rw_order_history_unavailable',
        'Order History is currently unavailable'
      )}
    </div>
  );
}
